module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img.ed67ad28.jpeg";